<template lang="html">
  <section class="">
    <div class="flex items-center justify-center">
      <section class="comment-rate">
        <p class="comment-rate-font ma2">{{ commentMedian || 0 }}</p>
        <p class="ma1 fw6 f3">Median Comments</p>
        <p class="ma1 mt2 fw6 f3">Per Student</p>
      </section>
      <pl-button
        @click.native="show_info_comment_rate = true"
        class="pl-icon"
        style="margin-right: -30px;"
      >
        <i class="fas fa-info-circle" />
      </pl-button>
    </div>
    <pl-dialog
      v-if="show_info_comment_rate"
      @close="show_info_comment_rate = false"
    >
      <p class="italics pl-subheading tc">
        This is the median number of comments per student in the RoundTable.
      </p>
      <pl-button
        @click.native="show_info_comment_rate = false"
        class="pl-primary"
      >
        OK
      </pl-button>
    </pl-dialog>
  </section>
</template>
<script>
  export default {
    data() {
      return {
        show_info_comment_rate: false,
      };
    },
    props: {
      commentRate: {
        type: Number,
        default: 0,
      },
      commentMedian: {
        type: Number,
        default: 0,
      },
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
  p.comment-rate-font
    font-weight: 600
    font-size: 80px
    color: pl-ruby
    margin: 0.5em
</style>



// WEBPACK FOOTER //
// roundtableSummaryCommentRate.vue?e14f2040